import { InvitationFirstLoginView } from '@today/ui-domain'
import { useParams } from 'react-router-dom'
import { useAuthLogo } from '@/auth/useAuthLogo'
import { useInvitationFirstLogin } from '@/hooks/useInvitationFirstLogin'

/**
 * `/t/:slug/invitation#token=…` — the link in the invitation email (TO-309).
 * Public: a native user sets their password here; a federated user is sent on
 * to their organisation's sign-in.
 */
export function InvitationFirstLoginPage() {
	const { slug = '' } = useParams()
	const logo = useAuthLogo()
	const { stage, email, errorCode, passwordRejected, isSubmitting, submitPassword } = useInvitationFirstLogin(slug)

	return (
		<InvitationFirstLoginView
			logo={logo}
			tenantSlug={slug}
			stage={stage}
			email={email}
			errorCode={errorCode}
			passwordRejected={passwordRejected}
			isSubmitting={isSubmitting}
			onSubmitPassword={submitPassword}
		/>
	)
}
